// extracted by mini-css-extract-plugin
export default {"noData-container":"NoDataComponent_noData-container__e8IjD"};